import styled from 'styled-components';

export const BreadcrumbStyled = styled.div`
  width: 100%;

  .breadcrumb {
    margin-bottom: 0;

    .breadcrumb-item.active {
      color: ${(props) => props?.theme?.text?.medium};
    }
    .breadcrumb-item {
      padding-left: 0;
      padding-right: 8px;
      font-weight: 600;

      a {
        color: ${(props) => props?.theme?.blue?.dark};
        font-size: 14px;
        text-decoration: none;
      }

      &::before {
        color: ${(props) => props?.theme?.blue?.grey};
      }

      .active {
        color: ${(props) => props?.theme?.text?.light};
      }
    }
  }

  &.epharmacy {
    .breadcrumb {
      .breadcrumb-item {
        a {
          color: ${(props) => props?.theme?.green?.dark};
        }

        .active {
          color: ${(props) => props?.theme?.text?.light};
        }
      }
    }
  }
  &.homecare {
    .breadcrumb {
      .breadcrumb-item {
        a {
          color: ${(props) => props?.theme?.blue?.royal};
        }

        .active {
          color: ${(props) => props?.theme?.text?.medium};
        }
      }
    }
  }

  @media (max-width: 768px) {
    .breadcrumb {
      overflow: hidden;
      white-space: nowrap;
      flex-wrap: nowrap;

      .breadcrumb-item {
        display: flex;
      }
    }
    &.homecare {
      .breadcrumb {
        overflow: auto;
        padding-bottom: 10px;
      }
    }
  }

  .breadcrumb-text {
    display: inline-block;
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &.rtl {
    .breadcrumb {
      .breadcrumb-item {
        padding-left: 8px;
        padding-right: 0;
        &:before {
          float: right;
          padding-left: 8px;
          padding-right: 0;
        }
      }
    }
  }
`;
